import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Global design theme: navy primary + pale-blue background (replaces purple/lavender)
const theme = createTheme({
  palette: {
    primary:   { main: '#336599', dark: '#244C77', light: '#4A7BA8', contrastText: '#fff' },
    secondary: { main: '#4A7BA8' },
    background: { default: '#F4F7FB', paper: '#FFFFFF' },
  },
  shape: { borderRadius: 10 },
  typography: { fontFamily: 'inherit', button: { textTransform: 'none', fontWeight: 600 } },
  components: {
    MuiButton: {
      styleOverrides: {
        containedPrimary: { background: 'linear-gradient(90deg, #4A7BA8, #244C77)' },
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
